export default {
      id: "map__car_type_fire-fighter-woman-usage",
      viewBox: "0 0 25 24",
      url: __webpack_public_path__ + "img/icons.svg#map__car_type_fire-fighter-woman",
      toString: function () {
        return this.url;
      }
    }